var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletAddBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7533 2.94671L13.54 10.4267H10.3267C9.79334 10.4267 9.27334 10.4667 8.76668 10.5734L10.1 7.37339L10.1533 7.25339L10.2333 7.04006C10.2733 6.94672 10.3 6.86672 10.34 6.80005C11.8867 3.21337 13.62 2.09337 16.7533 2.94671Z",
    fill: "#7D14FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7533 2.94671L13.54 10.4267H10.3267C9.79334 10.4267 9.27334 10.4667 8.76668 10.5734L10.1 7.37339L10.1533 7.25339L10.2333 7.04006C10.2733 6.94672 10.3 6.86672 10.34 6.80005C11.8867 3.21337 13.62 2.09337 16.7533 2.94671Z",
    fill: "url(#paint0_linear_1625_16615)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8067 10.7867L25.78 10.7733C24.98 10.5467 24.1667 10.4267 23.34 10.4267H14.9933L17.9933 3.45332L18.0333 3.35999C18.22 3.42665 18.42 3.51999 18.62 3.58665L21.5667 4.82666C23.2067 5.50666 24.3533 6.21333 25.06 7.06667C25.18 7.22667 25.2867 7.37333 25.3933 7.54667C25.5133 7.73334 25.6067 7.92 25.66 8.12C25.7133 8.24 25.7533 8.34667 25.78 8.46667C25.98 9.14667 25.9933 9.92001 25.8067 10.7867Z",
    fill: "#7D14FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8067 10.7867L25.78 10.7733C24.98 10.5467 24.1667 10.4267 23.34 10.4267H14.9933L17.9933 3.45332L18.0333 3.35999C18.22 3.42665 18.42 3.51999 18.62 3.58665L21.5667 4.82666C23.2067 5.50666 24.3533 6.21333 25.06 7.06667C25.18 7.22667 25.2867 7.37333 25.3933 7.54667C25.5133 7.73334 25.6067 7.92 25.66 8.12C25.7133 8.24 25.7533 8.34667 25.78 8.46667C25.98 9.14667 25.9933 9.92001 25.8067 10.7867Z",
    fill: "url(#paint1_linear_1625_16615)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.22 12.6934C24.62 12.52 23.9933 12.4267 23.34 12.4267H10.3267C9.42001 12.4267 8.56667 12.6 7.76667 12.9467C5.44667 13.9467 3.82001 16.2534 3.82001 18.9334V21.5334C3.82001 21.8534 3.84667 22.1601 3.88667 22.4801C4.18001 26.7201 6.44667 28.9868 10.6867 29.2668C10.9933 29.3068 11.3 29.3334 11.6333 29.3334H22.0333C26.9667 29.3334 29.5667 26.9868 29.82 22.3201C29.8333 22.0667 29.8467 21.8001 29.8467 21.5334V18.9334C29.8467 15.9867 27.8867 13.5067 25.22 12.6934ZM20.1667 21.5867H17.8333V24.0001C17.8333 24.5467 17.38 25.0001 16.8333 25.0001C16.2867 25.0001 15.8333 24.5467 15.8333 24.0001V21.5867H13.5C12.9533 21.5867 12.5 21.1467 12.5 20.5867C12.5 20.0401 12.9533 19.5867 13.5 19.5867H15.8333V17.3334C15.8333 16.7867 16.2867 16.3334 16.8333 16.3334C17.38 16.3334 17.8333 16.7867 17.8333 17.3334V19.5867H20.1667C20.7133 19.5867 21.1667 20.0401 21.1667 20.5867C21.1667 21.1467 20.7133 21.5867 20.1667 21.5867Z",
    fill: "#7D14FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.22 12.6934C24.62 12.52 23.9933 12.4267 23.34 12.4267H10.3267C9.42001 12.4267 8.56667 12.6 7.76667 12.9467C5.44667 13.9467 3.82001 16.2534 3.82001 18.9334V21.5334C3.82001 21.8534 3.84667 22.1601 3.88667 22.4801C4.18001 26.7201 6.44667 28.9868 10.6867 29.2668C10.9933 29.3068 11.3 29.3334 11.6333 29.3334H22.0333C26.9667 29.3334 29.5667 26.9868 29.82 22.3201C29.8333 22.0667 29.8467 21.8001 29.8467 21.5334V18.9334C29.8467 15.9867 27.8867 13.5067 25.22 12.6934ZM20.1667 21.5867H17.8333V24.0001C17.8333 24.5467 17.38 25.0001 16.8333 25.0001C16.2867 25.0001 15.8333 24.5467 15.8333 24.0001V21.5867H13.5C12.9533 21.5867 12.5 21.1467 12.5 20.5867C12.5 20.0401 12.9533 19.5867 13.5 19.5867H15.8333V17.3334C15.8333 16.7867 16.2867 16.3334 16.8333 16.3334C17.38 16.3334 17.8333 16.7867 17.8333 17.3334V19.5867H20.1667C20.7133 19.5867 21.1667 20.0401 21.1667 20.5867C21.1667 21.1467 20.7133 21.5867 20.1667 21.5867Z",
    fill: "url(#paint2_linear_1625_16615)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1625_16615",
    x1: 8.76668,
    y1: 2.67474,
    x2: 16.6649,
    y2: 10.6609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1625_16615",
    x1: 14.9933,
    y1: 3.35999,
    x2: 21.8945,
    y2: 13.5308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1625_16615",
    x1: 3.82001,
    y1: 12.4267,
    x2: 19.2669,
    y2: 36.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAddBold);
export default __webpack_public_path__ + "static/media/wallet-add-bold.46e161dc6c3c14574b8b652036066188.svg";
export { ForwardRef as ReactComponent };